import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectTypeDefinitionFetchFailedAction = {
	type: 'SUBJECT_TYPE_DEFINITION_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectTypeDefinitionFetchFailedAction => ({
	type: 'SUBJECT_TYPE_DEFINITION_FETCH_FAILED',
	payload,
});
